export const convertFileToBase64 = (url: string): Promise<string> => {
    return fetch(url)
      .then(response => response.blob())  
      .then(blob => {
        return new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            resolve(reader.result as string); 
          };
          reader.onerror = reject;
          reader.readAsDataURL(blob); 
        });
      });
  };